import React from "react";
import { FaChevronLeft } from "react-icons/fa";

const ServiceCard = ({ title, description, buttonText, onClick, delay = 0 }) => {
  return (
    <div
      className="group relative bg-white/40 backdrop-blur-xl rounded-2xl border border-white/20 shadow-xl p-5 sm:p-6 md:p-8 flex flex-col justify-between transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:border-main1/20 overflow-hidden animate-fadeUpSmooth h-full"
      style={{ animationDelay: `${delay}s` }}
    >
      {/* Decorative Glow */}
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-main1/5 rounded-full blur-3xl group-hover:bg-main1/10 transition-colors duration-500"></div>

      <div className="relative z-10 flex-1">
        <h5 className="text-base sm:text-lg md:text-xl font-extrabold text-main1 mb-3 group-hover:text-main2 transition-colors duration-300">
          {title}
        </h5>
        <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed font-medium">
          {description}
        </p>
      </div>

      <div className="mt-6 flex justify-end relative z-10">
        <button
          onClick={onClick}
          className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-main1 text-white text-xs sm:text-sm font-bold shadow-lg shadow-main1/10 hover:shadow-main1/30 hover:bg-main1/90 active:scale-95 transition-all group/btn"
        >
          <span>{buttonText}</span>
          <FaChevronLeft className="text-[10px] transition-transform duration-300 group-hover/btn:-translate-x-1" />
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;



